export default __webpack_public_path__ + "static/media/logo-ae-brands-for-less.a37400fb.svg";